<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper mine-index">
      <a-spin :spinning="spinning">
        <div class="content_index">
          <div class="content_left">
            <div
              class="header-top"
              :style="formData.back_style==2 && formData.pic.length>0 ? 'background:url('+formData.pic[0].url+')':''"
            >
              <div
                class="mine-title"
                :style="formData.back_style==1 ? 'color:#fff':'color:#000'"
              >个人中心</div>
              <div class="user-info">
                <div class="user-face-box">
                  <img
                    src="https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-08/1586308572623621.jpeg"
                    alt
                    srcset
                  />
                </div>
                <div class="user-info-right">
                  <p
                    class="user-name"
                    :style="formData.color_style==1 ? 'color:#fff':'color:#000'"
                  >昵称</p>
                  <p
                    class="user-consumption"
                    :style="formData.color_style==1 ? 'color:#fff':'color:#000'"
                  >
                    <span>消费¥2000.00</span>&nbsp;
                    <span>订单数48</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="order-box">
              <div class="order-box-top">
                <div>我的订单</div>
                <div>查看全部订单</div>
              </div>
              <div class="order-items">
                <div>
                  <img
                    class="order-foot-img1"
                    src="https://static.dierqudao.com/images/three1.png"
                    alt
                  />
                  <div style="margin-top:5px">待付款</div>
                </div>
                <div>
                  <img
                    class="order-foot-img2"
                    src="https://static.dierqudao.com/images/three2.png"
                    alt
                  />
                  <div style="margin-top:5px">待成单</div>
                </div>
                <div>
                  <img
                    class="order-foot-img3"
                    src="https://static.dierqudao.com/images/three3.png"
                    alt
                  />
                  <div style="margin-top:5px">待发货</div>
                </div>
                <div>
                  <img
                    class="order-foot-img4"
                    src="https://static.dierqudao.com/images/three4.png"
                    alt
                  />
                  <div style="margin-top:5px">待收货</div>
                </div>
                <div>
                  <img
                    class="order-foot-img5"
                    src="https://static.dierqudao.com/images/three5.png"
                    alt
                  />
                  <div style="margin-top:5px">售后中</div>
                </div>
              </div>
            </div>
            <div
              :class="formData.items_style==1 ? 'all-type flex-start':'all-type2 flex-start'"
              style="margin-top:90px"
            >
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-address.png" />
                <div>收货地址</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <!-- <div class='badge'>3</div> -->
                <img src="https://static.dierqudao.com/images/icon-mine-order.png" />
                <div>订单</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-coupon.png" />
                <div>优惠券</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-tuan.png" />
                <div>拼团</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-kanjia.png" />
                <div>砍价</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-jielong.png" />
                <div>接龙</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-guafen.png" />
                <div>瓜分券</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-luck.png" />
                <div>抽奖</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-pinjianshi.png" />
                <div>我是品荐师</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-help.png" />
                <div>帮助</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-kefu.png" />
                <div>客服</div>
              </div>

              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-shop.png" />
                <div>我的门店</div>
              </div>
              <div :class="formData.items_style==1 ? 'all-type-one':'all-type-one2'">
                <img src="https://static.dierqudao.com/images/icon-mine-business.png" />
                <div>我是商家</div>
              </div>
            </div>
            <div style="height:200px;width:100%"></div>
          </div>
          <div class="content_right">
            <a-form>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="背景样式" hasFeedback>
                <a-radio-group
                  name="radioGroup"
                  v-model="formData.back_style"
                  @change="radioBackChange"
                >
                  <a-radio :value="1">默认样式</a-radio>
                  <a-radio :value="2">自定义背景</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                v-if="formData.back_style==2"
                label="背景图片"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                extra="推荐尺寸750x550,推荐格式jpg"
              >
                <pic-uploader :file-list="formData.pic" :numberLimit="1" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字体颜色" hasFeedback>
                <a-radio-group
                  name="radioGroup"
                  v-model="formData.color_style"
                  @change="radioColorChange"
                >
                  <a-radio :value="1">白色字体</a-radio>
                  <a-radio :value="2">黑色字体</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="菜单样式" hasFeedback>
                <a-radio-group
                  name="radioGroup"
                  v-model="formData.items_style"
                  @change="radioItemsChange"
                >
                  <a-radio :value="1">平铺展开</a-radio>
                  <a-radio :value="2">卡片类型</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-form>
          </div>
        </div>

        <div class="content_foote_btn">
          <a-button type="primary" class="btn" @click="contetAdd" :loading="spinning">保存更改</a-button>
          <!-- <a-button type="primary" class="btn">存入草稿</a-button> -->
        </div>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import PicUploader from '@/components/PicUploader/'
import { mineStyleAdd, getMineStyleDetail } from '@/api/page'
export default {
  name: 'MineIndex',
  components: { PicUploader },
  data() {
    return {
      spinning: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      formData: {
        pic: [],
        back_style: 1,
        color_style: 1,
        items_style: 1
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      let that = this
      this.form.resetFields()

      getMineStyleDetail().then(res => {
      //  setTimeout(() => {
      //   that.form.setFieldsValue({ ...res.data })
      // },1)
        that.formData = res.data
        // that.formData.back_style = '2'
        console.log(this.formData)
      })
    },
    contetAdd() {
      this.spinning = true
      let that = this
      console.log(this.formData)
      mineStyleAdd(this.formData)
        .then(res => {
          that.formData = res.data
          this.spinning = false
        })
        .then(rs => {})
    },
    radioBackChange(e) {
      console.log(e.target.value)
      this.formData.back_style = e.target.value
    },
    radioColorChange(e) {
      this.formData.color_style = e.target.value
    },
    radioItemsChange(e) {
      this.formData.items_style = e.target.value
    }
  },
  mounted() {}
}
</script>

<style lang="less">
.mine-index .all-type-one2 {
  width: 25%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}
.mine-index .all-type-one2 img {
  width: 30px;
  height: 30px;
}
.mine-index .all-type2 {
  width: 345px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 10px 0;
  flex-wrap: wrap;
}
.mine-index .font-color-box {
  display: flex;
}
.mine-index .color-boxs {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
}
.mine-index .color-box {
  width: 15px;
  height: 15px;
  border: 1px solid #ccc;
}
.mine-index .flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.mine-index .all-type {
  background: #fff;
  margin-top: 10px;
  flex-wrap: wrap;
}

.mine-index .all-type-one {
  width: 25%;
  text-align: center;
  padding: 12px 0;
  border-right: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  position: relative;
}

.mine-index .all-type-one:nth-child(4n) {
  border-right: none;
}

.mine-index .all-type-one img {
  width: 30px;
  height: 30px;
}

.mine-index .order-items {
  display: flex;
  justify-content: space-around;
  padding: 15px 0;
}
.mine-index .order-items div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mine-index .order-foot-img1 {
  width: 20px;
  height: 17px;
}

.mine-index .order-foot-img2 {
  width: 20px;
  height: 20px;
}

.mine-index .order-foot-img3 {
  width: 24px;
  height: 19px;
}

.mine-index .order-foot-img4 {
  width: 20px;
  height: 17px;
}

.mine-index .order-foot-img5 {
  width: 20px;
  height: 19px;
}
.mine-index .order-box-top {
  display: flex;
  justify-content: space-between;
  padding: 10px 17px;
  border-bottom: 1px solid #ccc;
}
.mine-index .order-box {
  width: 345px;
  // height: 117px;
  background: #fff;
  border-radius: 10px;
  margin: -60px auto;
}
.mine-index .user-name {
  font-size: 16px;
}
.mine-index .user-consumption {
  font-size: 10px;
}
.mine-index .user-info-right {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.mine-index .user-info-right p {
  margin-bottom: 0;
}
.mine-index .user-face-box {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid #fff;
  overflow: hidden;
}
.mine-index .user-face-box img {
  width: 100%;
}
.mine-index .user-info {
  width: 325px;
  margin: 50px auto;
  display: flex; 
}
.mine-index .mine-title {
  color: #fff;
  padding-top: 20px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
}
.mine-index .header-top {
  width: 375px;
  height: 275px;
  background: pink;
  background-size: 375px 275px !important;
  background-repeat: no-repeat !important;
}

.mine-index .content_left {
  width: 375px;
  height: 100%;
  background: #f8f8f8;
  overflow: scroll;
}
.mine-index .content_right {
  flex: 1;
  margin-left: 20px;
  background: #f8f8f8;
  padding: 20px;
}
.mine-index .content_index {
  width: 100%;
  height: 600px;
  display: flex;
}
.mine-index .content_foote_btn {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}
.mine-index .btn {
  margin: 0 10px;
}
.custom-tree {
  /deep/ .ant-menu-item-group-title {
    position: relative;
    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .ant-menu-item {
    &:hover {
      .btn {
        display: block;
      }
    }
  }

  /deep/ .btn {
    display: none;
    position: absolute;
    top: 0;
    right: 10px;
    width: 20px;
    height: 40px;
    line-height: 40px;
    z-index: 1050;

    &:hover {
      transform: scale(1.2);
      transition: 0.5s all;
    }
  }
}
</style>